class SiteHeader extends HTMLElement {
  connectedCallback() {
    this.menuToggle = this.querySelector('[data-menu-toggle]');
    this.mobileMenu = this.querySelector('[data-mobile-menu]');
    this.searchToggle = this.querySelector('[data-search-toggle]');
    this.mobileSearch = this.querySelector('[data-mobile-search]');
    this.cartTrigger = this.querySelector('#cartDrawerTrigger');

    this.menuToggle?.addEventListener('click', () => this.toggle(this.menuToggle, this.mobileMenu));
    this.searchToggle?.addEventListener('click', () => this.toggle(this.searchToggle, this.mobileSearch));
    this.cartTrigger?.addEventListener('click', () => this.openCartDrawer());

    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        this.close(this.menuToggle, this.mobileMenu);
        this.close(this.searchToggle, this.mobileSearch);
        this.closeCartDrawer();
      }
    });

    this.mobileMenu?.addEventListener('click', (event) => {
      if (event.target.closest('a')) {
        this.close(this.menuToggle, this.mobileMenu);
      }
    });

    this.syncHeaderHeight();
    window.addEventListener('resize', () => this.syncHeaderHeight());
  }

  openCartDrawer() {
    const cartDrawer = document.querySelector('#cartDrawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }

  closeCartDrawer() {
    const cartDrawer = document.querySelector('#cartDrawer');
    if (cartDrawer) {
      cartDrawer.close();
    }
  }

  syncHeaderHeight() {
    const header = this.querySelector('.site-header') || this;
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
  }

  toggle(toggleButton, panel) {
    if (!toggleButton || !panel) return;
    const isOpen = toggleButton.getAttribute('aria-expanded') === 'true';
    isOpen ? this.close(toggleButton, panel) : this.open(toggleButton, panel);
  }

  open(toggleButton, panel) {
    toggleButton.setAttribute('aria-expanded', 'true');
    panel.hidden = false;
    toggleButton.classList.add('is-active');
  }

  close(toggleButton, panel) {
    if (!toggleButton || !panel) return;
    toggleButton.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    toggleButton.classList.remove('is-active');
  }
}

customElements.define('site-header', SiteHeader);
